<template>
  <ContentBox title="Create Support Ticket">
    <template v-slot:content>

      <div v-if="!ticketCreated">
        <FormUploadDropTarget @filesDropped="$refs.documentUpload.filesDroppedFromTarget($event)">

          <!-- <NotificationBar type="info">
            <NotificationBarTitle>You currently have </NotificationBarTitle>
          </NotificationBar>
          -->

          <FormGroup :form="form">
            <FormRow label="Name">
              <FormInputText v-model="ticket.name" placeholder="Name" />
            </FormRow>
            <FormRow label="Reply Email">
              <FormInputText v-model="ticket.email" placeholder="Email" note="Email address for future communications regarding this ticket" />
            </FormRow>
            <FormRow label="Support Query">
              <FormSelect v-model="ticket.type" placeholder="Query" :options="supportTypeLookup" />
            </FormRow>
            <FormRow label="Subject">
              <FormInputText v-model="ticket.subject" placeholder="Subject" />
            </FormRow>
            <FormRow label="Details">
              <FormInputTextArea v-model="ticket.details" :rows="6" placeholder="Details" />
            </FormRow>

            <FormRow label="Attachments">
              <FormUpload ref="documentUpload" v-model="ticket.uploadFileList" field="uploadFileList" :showBrowseButton="true" />
            </FormRow>

            <FormSubmit label="Create Ticket" :submitting="submitting" @submitted="onSubmitted" @cancelled="onCancelled" />
          </FormGroup>

        </FormUploadDropTarget>
      </div>

      <div v-if="ticketCreated">
        <NotificationBar type="success">
          <NotificationBarTitle>Support Ticket Submitted</NotificationBarTitle>
          Thank you for contacting support. We will attempt to reply to your ticket as soon as possible.<br />
        </NotificationBar>
      </div>

    </template>
  </ContentBox>
</template>


<script>
import { mapState } from "vuex"
import formMixin from '@/mixins/form'

export default {
  name: 'SupportTicketNew',
  mixins: [formMixin],
  data() {
    return {
      submitting: false,
      ticketCreated: false,
      form: {},
      ticket: {
        name: '',
        email: '',
        type: 'Problem',
        subject: '',
        details: '',
        uploadFileList: []
      },
      // Types - Should match Freshdesk
      supportTypeLookup: [
        { name: 'Problem', value: 'Problem' },
        { name: 'Incident', value: 'Incident' },
        { name: 'Bug', value: 'Bug' },
        { name: 'Question', value: 'Question' },
        { name: 'General Inquiry', value: 'General inquiry' },
        { name: 'Billing', value: 'Billing' }
      ]
    }
  },
  computed: {
    ...mapState({
      profileUser: state => state.profile.profileUser
    }),
  },
  watch: {
    profileUser: {
      deep: true,
      immediate: true,
      handler: function() {
        this.ticket.name = this.profileUser.name
        this.ticket.email = this.profileUser.email
      }
    }
  },
  mounted() {
    
  },
  methods: {
    onSubmitted() {
      this.submitting = true

      this.$apiService.supportService.createSupportTicket(this.ticket)
      .then(response => {
        this.ticketCreated = true
      })
      .catch(err => {
        this.form = this.processFormResponse(err)
      })
      .finally(() => {
        this.submitting = false
      })
    },
    onCancelled() {
      this.$router.push('/')
    }
  }
}
</script>